import { css } from "@emotion/react";
import { useRef, useState } from "react";
import { Send } from "./icons";

export interface InputProps {
  onMessageSend: (message: string) => void;
}

const Input = ({ onMessageSend }: InputProps) => {
  const [message, setMessage] = useState<string>("");
  const messageRef = useRef<HTMLTextAreaElement>(null);

  return (
    <div
      css={css`
        padding: 10px 20px;
      `}
    >
      <div
        css={css`
          background: #ffffff;
          border: 2px solid #cbced1;
          border-radius: 800px;
          display: flex;
          padding: 5px 10px 5px 15px;
        `}
      >
        <textarea
          ref={messageRef}
          css={css`
            appearance: none;
            border: 0px;
            flex-grow: 1;
            font-family: "Poppins";
            font-size: 13px;
            line-height: 1.2em;
            outline: none;
            resize: none;
            height: 100%;
            padding-top: 5px;
            margin-right: 10px;
          `}
          placeholder="Escrever mensagem..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              !e.shiftKey &&
              !e.ctrlKey &&
              message.trim().length > 0
            ) {
              e.preventDefault();
              onMessageSend(message);
              setMessage("");
              messageRef.current?.focus();
            }
          }}
        />

        <div
          css={css`
            align-items: center;
            cursor: pointer;
            background-color: #dddddf;
            border-radius: 50%;
            display: flex;
            padding: 5px 5px 5px 8px;
            width: 38px;
            height: 38px;
            min-width: 38px;
            min-height: 38px;
            justify-content: center;
          `}
          onClick={() => {
            if (message.trim().length > 0) {
              onMessageSend(message);
              setMessage("");
              messageRef.current?.focus();
            }
          }}
        >
          <img
            src={Send}
            css={css`
              align-items: center;
              cursor: pointer;
              display: flex;
            `}
          />
        </div>
      </div>
    </div>
  );
};

export default Input;
